/* Phase 5 · Job Work Challan register + creator (coordinator+ / stores+ / qc)
 * Bilingual, mobile-first, matches HAG design system.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const AGE_STYLE = { green: "bg-emerald-50 text-emerald-800", amber: "bg-amber-50 text-amber-800", red: "bg-red-50 text-red-800" };

export default function JobWorkRegister() {
  const { lang } = useLang();
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("Open");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/job-work/challans", { params: status ? { status } : {} });
      setRows(r.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  return (
    <div className="p-4 md:p-6" data-testid="jw-register">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-[#7C8E9E]">JOB WORK · GST §143</div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#0B2340]">
            {lang === "hi" ? "जॉब वर्क चालान रजिस्टर" : "Job Work Challan Register"}
          </h1>
        </div>
        <Link to="/coordinator/job-work/new" data-testid="jw-new-btn"
          className="px-4 py-2 rounded-full bg-[#B08B49] text-white text-sm hover:bg-[#95753d]">
          + {lang === "hi" ? "नया चालान" : "New Challan"}
        </Link>
      </div>

      <div className="flex gap-2 mb-4">
        {["Open", "Closed", "ShortClosed", ""].map(s => (
          <button key={s} onClick={() => setStatus(s)} data-testid={`jw-filter-${s || "all"}`}
            className={`px-3 py-1 rounded-full text-xs ${status === s ? "bg-[#0B2340] text-white" : "bg-white border border-slate-200"}`}>
            {s || "All"}
          </button>
        ))}
        <Link to="/coordinator/job-workers" data-testid="jw-workers-link"
          className="ml-auto text-xs text-[#4A627A] underline">
          {lang === "hi" ? "जॉब वर्कर मास्टर" : "Job Worker master"}
        </Link>
      </div>

      {loading ? (
        <div className="p-4 text-sm text-[#7C8E9E]">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="p-6 text-sm text-[#7C8E9E] bg-white rounded-lg border border-slate-100">
          {lang === "hi" ? "कोई चालान नहीं।" : "No challans yet. Click New Challan to create one."}
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg border border-slate-100">
          <table className="min-w-full text-sm" data-testid="jw-table">
            <thead className="text-[11px] uppercase tracking-wider text-[#7C8E9E]">
              <tr className="border-b border-slate-100">
                <th className="text-left p-3">Challan No</th>
                <th className="text-left p-3">Date</th>
                <th className="text-left p-3">Job Worker</th>
                <th className="text-left p-3">Purpose</th>
                <th className="text-right p-3">Pcs / Mat Bal.</th>
                <th className="text-left p-3">Return by</th>
                <th className="text-center p-3">Age</th>
                <th className="text-left p-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="p-3 font-mono">
                    <Link to={`/coordinator/job-work/${r.id}`} data-testid={`jw-row-${r.challan_no}`}
                      className="text-[#0B2340] underline">
                      {r.challan_no}
                    </Link>
                  </td>
                  <td className="p-3">{r.date?.slice(0, 10)}</td>
                  <td className="p-3">{r.job_worker_name}</td>
                  <td className="p-3">{r.purpose}</td>
                  <td className="p-3 text-right">{r.balance_pieces} pcs / {r.balance_materials}</td>
                  <td className="p-3">{r.expected_return_date}</td>
                  <td className="p-3 text-center">
                    <span className={`px-2 py-0.5 rounded-full text-[10px] uppercase ${AGE_STYLE[r.ageing_flag]}`}>
                      {r.ageing_flag}
                    </span>
                  </td>
                  <td className="p-3">{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
